
export const sFechaPublicacion = '2026-09-01T17:41:30.5824995-06:00';
export const sVersion = 'vAI0.1.609011741';
            